import { render, staticRenderFns } from "./contacts-container.vue?vue&type=template&id=2dfe581a&scoped=true&lang=pug"
import script from "./contacts-container.vue?vue&type=script&lang=ts"
export * from "./contacts-container.vue?vue&type=script&lang=ts"
import style0 from "./contacts-container.vue?vue&type=style&index=0&id=2dfe581a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfe581a",
  null
  
)

export default component.exports